import { render } from "./AddCommentDialog.vue?vue&type=template&id=77b0d638&scoped=true&ts=true"
import script from "./AddCommentDialog.vue?vue&type=script&lang=ts"
export * from "./AddCommentDialog.vue?vue&type=script&lang=ts"

import "./AddCommentDialog.vue?vue&type=style&index=0&id=77b0d638&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77b0d638"]])

export default __exports__